module.exports = __webpack_public_path__ + "static/media/institute-3-min.8fcd669b.webp";